import _axios from '../../apiClient'

export function getConfigVidriera() {
  return _axios
    .get(`/ConfigGlobal/GetModoVidriera`, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data.vidriera)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getModalidad() {
  return _axios
    .get('/ConfigGlobal/GetModalidad')
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.error('Error al obtener la modalidad:', error)
      throw error
    })
}
